export { default as Addresses } from './Addresses';
export { default as LabOrders } from './LabOrders';
export { default as Referrals } from './Referrals';
export { default as RoutineExams } from './RoutineExams';
export { default as Notes } from './Notes';
